import { render, staticRenderFns } from "./LkFounder.vue?vue&type=template&id=471aa28a&"
import script from "./LkFounder.vue?vue&type=script&lang=js&"
export * from "./LkFounder.vue?vue&type=script&lang=js&"
import style0 from "./LkFounder.vue?vue&type=style&index=0&id=471aa28a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports